export default "__VITE_PUBLIC_ASSET__aea944c4__"